// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SvgIconCheckboxChecked = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3H6zm10.98 5.425a.75.75 0 10-1.236-.85l-4.99 7.257-2.362-2.362a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.148-.105l5.5-8z"
      fill="currentColor"
    />
  );
export default SvgIconCheckboxChecked;
